import { lazy, Suspense } from 'react';

// Lazy load form components
const UserForm = lazy(() => import('./UserForm'));
const DriverForm = lazy(() => import('./DriverForm'));
const VehicleForm = lazy(() => import('./VehicleForm'));

// Loading component for forms
const FormLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    color: 'var(--text)'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{
        width: '24px',
        height: '24px',
        border: '3px solid rgba(255,255,255,0.1)',
        borderTop: '3px solid var(--secondary)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 8px'
      }}></div>
      <p style={{ fontSize: '14px', opacity: 0.7 }}>Cargando formulario...</p>
    </div>
  </div>
);

// Wrapper components with Suspense
export const LazyUserForm = (props) => (
  <Suspense fallback={<FormLoader />}>
    <UserForm {...props} />
  </Suspense>
);

export const LazyDriverForm = (props) => (
  <Suspense fallback={<FormLoader />}>
    <DriverForm {...props} />
  </Suspense>
);

export const LazyVehicleForm = (props) => (
  <Suspense fallback={<FormLoader />}>
    <VehicleForm {...props} />
  </Suspense>
);
